export default {
  'app.console.nodata': 'データがありません',
  'app.console.recents': '最近のアクティビティ',
  'app.console.recents.nodata': '利用可能なデータがありません。まずサービスを有効化してください。',
  'app.console.channel': '開通待ちサービス',
  'app.console.channel.active': '開通済みサービス',
  'app.console.channel.activateService': 'はじめる',
  'app.console.channel.learnMore': 'さらに詳しく',
  'app.console.channel.sendNum': '送信数',
  'app.console.channel.targetNum': 'ターゲット数',
  'app.console.channel.deliveredNum': '配信数',
  'app.console.channel.clickNum': 'クリック数',
  'app.console.channel.readNum': '読み込み数',
  'app.console.channel.sendNumRate': '送信率',
  'app.console.channel.deliveredNumRate': '到達率',
  'app.console.channel.clickNumRate': 'CTR',
  'app.console.channel.readNumRate': '読み込み率',
  'app.console.channel.title1': '過去7日間のトレンド',
  'app.console.channel.title2': '過去7日間のコンバージョン',
  'app.console.channel.sendOut': 'メッセージを送信',
  'app.console.channel.start': 'はじめる',
  'app.console.channel.message.activated': '有効化済み',
  'app.console.channel.message.apppush':
    'わずか3分でSDK統合を完了し、インテリジェントで正確なプッシュを実現し、ユーザー活性化とリテンションを効果的に向上。',
  'app.console.channel.message.email':
    '高効率で安定したメール送信APIを提供し、独立したIP設定、BIMI認証をサポートし、リアルタイムの正確なデータフィードバックにより配信率を最適化。',
  'app.console.channel.message.sms':
    '統合SMS機能で、従来の携帯通信サービスとインターネットを組み合わせ、企業の真のグローバル化を実現。',
  'app.console.channel.message.whatsapp':
    'WhatsApp Business APIを使用して、20億を超えるグローバルユーザーとのより緊密な接続を構築。',
  'app.console.channel.message.OTP':
    'EngageLab OTPはワンタイムパスワードの生成と検証サービスを提供し、WhatsApp、SMS、音声、メールのマルチチャネル配信をサポートし、確実な配信とコンバージョンを保証。',
  'app.console.channel.message.webpush':
    'モバイルアプリに依存せず、ウェブサイト購読者にマーケティングメッセージやサービス通知をいつでもプッシュ可能、ユーザーエンゲージメントとコンバージョン向上を実現。',
  'app.console.channel.message.edm':
    'ワンクリックインストールでコーディング不要、ストアが簡単にメールマーケティングを実施し、自動化で顧客の購買を促進し、収益向上を実現。',
  'app.console.channel.message.ma':
    'マーケティング自動化サービスは、ユーザーデータ管理とユーザージャーニー構築をサポートし、マルチチャネルでユーザーにリーチし、迅速でパーソナライズされた体験を提供。',
  'app.console.channel.message.captcha':
    '行動型CAPTCHA、機械スクリプトプログラムの自動化攻撃によるビジネス損失とセキュリティリスクを解決',
  //AI 驱动的客户服务平台，完美处理 90% 的客户问题
  'app.console.channel.message.livedesk':
    'AI 駆動の顧客サービスプラットフォーム，90% の顧客問題を完璧に処理。',
  'app.console.channel.message.silentauth':
    'サイレント認証サービス、安全でシームレスなユーザー身元確認ソリューションを提供。',
  'app.console.channel.flag.email': '受信箱インサイト',
  'app.console.doc': 'REST APIドキュメント',
  'app.console.doc.apppush': 'AppPushドキュメント',
  'app.console.doc.email': 'Emailドキュメント',
  'app.console.doc.sms': 'SMSドキュメント',
  'app.console.doc.newsms': 'SMSドキュメント',
  'app.console.doc.whatsapp': 'WhatsAppドキュメント',
  'app.console.doc.webpush': 'WebPushドキュメント',
  'app.console.doc.edm': 'EDMドキュメント',
  'app.console.doc.otp': 'OTPドキュメント',
  'app.console.doc.ma': 'Marketing Automationドキュメント',
  'app.console.doc.captcha': 'CAPTCHAドキュメント',
  'app.console.doc.livedesk': 'Livedeskドキュメント',
  'app.console.doc.silentauth': 'Silent Authドキュメント',
  'app.console.manage': '設定',
  'app.console.manage.orders': '注文と請求書',
  'app.console.manage.pending': '支払い待ち注文',
  'app.console.manage.supplementary': '支払い待ち請求書',
  'app.console.manage.notification': 'サービス通知',
  'app.console.manage.faq': 'よくあるご質問',
  'app.console.manage.download': 'ダウンロード',
  'app.console.channel.verifiedRate': 'フィードバック率',
  'app.console.channel.verifiedNum': 'フィードバック数',
  'app.console.channel.select.all': 'すべて',
  'app.console.channel.requestCount': 'リクエスト数',
  'app.console.channel.successCount': '成功数',
  'app.console.channel.failCount': '失敗数',
  'app.console.channel.successRate': '成功率',
  'app.console.channel.failRate': '失敗率',
};
